module.exports = __webpack_public_path__ + "static/media/scissors_02.e0b15f43.png";